<template>
  <el-form :model="formData" ref="form" :rules="formRules">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item :label="$t('leaver.name')" prop="leaverName">
          <el-autocomplete
                class="inline-input"
                v-model="formData.leaverName"
                :fetch-suggestions="querySearchUser"
                :placeholder="$t('vendor.contract.sp-ph')"
                @select="handleSelectUser"
                style="width:100%"
                :clearable="true"
              ></el-autocomplete>
        </el-form-item>
        
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('leaver.last-day')" prop="endDate">
          <el-date-picker
              v-model="formData.endDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="$t('vendor.contract.select-date')"
              style="width:100%"
              >
            </el-date-picker>
        </el-form-item>
      </el-col>
      <!--<el-col :span="24">
        <el-form-item :label="$t('leaver.leave-reason')" prop="leaveReason">
          <el-cascader
              expand-trigger="hover"
              :options="leaveReason"
              :props="optionProps"
              v-model="formData.leaveReason"
              style="width:100%"
              :clearable="true">
          </el-cascader>
        </el-form-item>
      </el-col>-->
      <el-col :span="24">
        <el-form-item :label="$t('leaver.comment')">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4}"
            v-model="formData.comment"
            style="width:100%">
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-checkbox v-model="formData.keepEmail">{{ $t('leaver.email') }}</el-checkbox>
      </el-col>
      <el-col :span="12" v-if="formData.keepEmail == true">
        <el-form-item :label="$t('leaver.forward')">
          <el-autocomplete
                class="inline-input"
                v-model="formData.forwarder"
                :fetch-suggestions="querySearchUser"
                :placeholder="$t('vendor.contract.sp-ph')"
                @select="handleSelectForwarder"
                style="width:100%"
                :clearable="true"
              ></el-autocomplete>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-checkbox v-model="formData.backup">{{ $t('leaver.backup') }}</el-checkbox>
      </el-col>
      <el-col :span="12">
        <el-checkbox v-model="formData.caseReassign">{{ $t('leaver.case') }}</el-checkbox>
      </el-col>
    </el-row>
  </el-form>
</template>
<style scoped>
</style>
<script>
import moment from 'moment'
import { Loading } from 'element-ui'

export default {
  name: 'LeaverForm',
  data: function() {
  return {
    formData: {
        'id': null,
        'userId': null,
        'leaverId': null,
        'leaverName': null,
        'endDate': moment().format('YYYY-MM-DD'),
        'leaveReason': null,
        'comment': null,
        'keepEmail': false,
        'forwarder': null,
        'forwarderId': null,
        'backup': false,
        'caseReassign': false
      },
    formRules: {
        'leaverName': [{required: true, message: this.$t('leaver.validate.user'), trigger: 'blur'}],
        'endDate': [{required: true, message: this.$t('leaver.validate.last-day'), trigger: 'blur'}],
        'leaveReason': [{required: true, message: this.$t('leaver.validate.leave-reason'), trigger: 'blur'}],
    },
    optionProps: {
      value: 'id',
      label: this.$i18n.locale === 'zh' ? 'c_name' : 'e_name',
      children: 'sub_category'
    },
    users: []
  }
  },
  computed: {
    
  },
  watch: {
    
  },
  methods: {
    createLeaver: function() {
      this.$refs.form.validate(valid => {
        if (valid) {
          //close model
          console.log(this.formData)
          let loading = Loading.service({ fullscreen: true }),
              that = this
          this.formData.userId = localStorage.getItem('token')
          this.$http.post(this.API3_PREFIX + 'leaver', this.formData).then(function (response) {
        that.$nextTick(() => {
        loading.close();
        })
            that.$message({
            message: that.$t('leaver.success'),
            type: 'success'
          })
          that.$refs.form.resetFields()
          that.$emit('value-save', that.formData)
      }).catch(function (error) {
      console.log(error)
      that.$nextTick(() => {
        loading.close();
      })
      that.$message({
            message: that.$t('leaver.failed'),
            type: 'error'
          })
        })
        } else {
          // do stuff if not valid.
          this.$message({
            message: this.$t('leaver.invalid'),
            type: 'error'
          })
          return false
        }
      })
    },
    querySearchUser: function(queryString, cb) {
      //get users api/suggest/user
      let that = this,
        query = '?filter%5Bname%5D=' + encodeURI(queryString) + 
        '&filter%5Bgroup%5D=true&results_per_page=20&_=' + Date.parse(new Date())

      this.$http.get(this.API_PREFIX + '/api/suggest/user' + query).then(function (response) {
      that.users = response.data.hits
      that.users.forEach(function(user, i) {
          user.value = user.data.nickname
      })
      //console.log(that.users)
      cb(that.users)
    }).catch(function (error) {
      console.log(error)
    })
    },
    handleSelectUser: function(item) {
      this.formData.leaverId = item.data.id
    },
    handleSelectForwarder: function(item) {
      this.formData.forwarderId = item.data.id
    }
  },
  created: function() {
    
  }
}
</script>